import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import NiceSelect from './NiceSelect';
import MobileMenu from './MobileMenu';
import LoginForm from './LoginForm';

function HeaderOne() {
    const languageOptions = [
        { value: "language", label: "Language" },
        { value: "CNY", label: "CNY" },
        { value: "EUR", label: "EUR" },
        { value: "AUD", label: "AUD" },
    ];
    const [isSticky, setIsSticky] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isLoginFormOpen, setIsLoginFormOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 500) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            {/*============================== Header Area ==============================*/}
            <header className="th-header header-layout1">
            
                <div className={`sticky-wrapper ${isSticky ? "sticky" : ""}`}>
                    {/* Main Menu Area */}
                    <div className="menu-area">
                        <div className="container th-container  ">
                            <div className="row align-items-center justify-content-between" >
                                <div className="col-auto" >
                                    <div className="header-logo"  >
                                        <Link to="/">
                                            <img src="/assets/img/logo-white2.png"  style={{ width: "140px", marginLeft:"40%" }} alt="Visto Planet" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-auto ">
                                    <nav className="main-menu d-none d-xl-inline-block">
                                        <ul>
                                            <li className=" mega-menu-wrap">
                                                <Link className="" to="/">
                                                    Home
                                                </Link>
                                                
                                            </li>
                                            <li>
                                                <Link to="/about">About Us</Link>
                                                
                                            </li>

                                             <li className="">
                                                <Link to="/global-visa">Global Visa</Link>
                                            
                                            </li>
                                            <li className="">
                                                <Link to="/Holidays">Holiday Packages</Link>
                                            </li>
                                           
                                           
                                           
                                            <li>
                                                <Link to="/Contact">Contact us</Link>
                                            </li>
                                        </ul>
                                    </nav>
                                    <button
                                        type="button"
                                        className="th-menu-toggle d-block d-xl-none"    
                                        onClick={() => setIsMobileMenuOpen(true)}
                                    >
                                        <i className="far fa-bars" />
                                    </button>
                                </div>
                                <div className="col-auto d-none d-xl-block">
                                    <div className="header-button">
                                        <Link to="/Contact" className="th-btn style3 th-icon">
                                            Book Now
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="logo-bg bg-mask"
                            // style={{
                            //     WebkitMaskImage: "url(/assets/img/logo_bg_mask.png)",
                            //     maskImage: "url(/assets/img/logo_bg_mask.png)"
                            // }}
                             /> */}
                    </div>
                </div>
            </header>
            <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
            <LoginForm isOpen={isLoginFormOpen} onClose={() => setIsLoginFormOpen(false)} />
        </>

    )
}

export default HeaderOne
